<template>
    <div class="container">
        <div>
            <p>- WEB XR </p>
            <div class="projectsContent">
                <ProjectCard path='../Interfaces' title="Interfaces" link="https://github.com/Carnaux/Interfaces">
                    A library to create dynamic HTML interfaces for Three.js scenes. Also you can use it with Vue.js!
                </ProjectCard>
                <ProjectCard path='../NFTCreator' title="NFT Marker Creator" link="https://github.com/Carnaux/NFT-Marker-Creator">
                    Generator of Image descriptors for Tracking in AR.js and jsartoolkit5.
                </ProjectCard>
                <ProjectCard path='../Zft' title="ZFT Creator" link="https://github.com/Carnaux/ZFT-Creator">
                    This node app deflate and inflate artoolkit NFT marker files to a single .zft file.
                </ProjectCard>
                <ProjectCard path='../Vuear' title="Vue-AR" link="https://github.com/Carnaux/Vue-AR">
                    A button component for enabling AR experiences with Vue.js.
                </ProjectCard>
            </div>
        </div>
        <div>
            <p>- Web Software </p>
            <div class="projectsContent">
                <ProjectCard path='../WebPlat' title="Web Platform For Robotics" link="https://github.com/Carnaux/WebPlatformForRobotics">
                    A prototype of a web based plataform for analysis of robot arms. (Published Paper)
                </ProjectCard>
                <ProjectCard path='../Ro' title="Room" link="https://carnaux.github.io/Room/">
                    Dynamically simulate people flow in buildings.
                </ProjectCard>
                <ProjectCard path='../City' title="City Resources" link="https://github.com/Carnaux/City-Resources">
                    Simulates the production of water and energy of a city based on the rain regime.
                </ProjectCard>
                <ProjectCard path='../Arch' title="Archnoi" link="https://carnaux.github.io/Archnoi/">
                    Voronoi based procedural generation of architecture.
                </ProjectCard>
            </div>
            <!-- <p class="subTitle">- Experimental</p> -->
        </div>   
        <Footer></Footer>
    </div>
</template>

<script>
import ProjectCard from './ProjectCard';
import Footer from '../components/Footer';

export default {
    name: 'Projects',
    components: { 
        ProjectCard,
        Footer
    },
    props: {},
    
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

    .container{
        width: 100%;
        height: 95%;
        /* background-color: red; */
        margin-right: 20px;
        margin-left: 10px;
        margin-top: 50px;
    }
    p{
        font-size: 40px;
        font-family: 'Bebas Neue', cursive;
    }
    .subTitle{
        font-size: 30px;
        color: rgb(50,50,50)
    }
    .projectsContent{
        display: grid;
        grid-template-columns: auto auto auto; 
        margin-right: 10px;
    }

    @media only screen and (max-width: 600px) {
        .projectsContent{
            grid-template-columns: auto auto; 
        }
    }
</style>